import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionAccountingStateForm_UpdateAccountingInfoState_Mutation =
  graphql(`
    mutation MissionAccountingStateForm_UpdateAccountingInfoState(
      $actionId: Id!
      $missionId: Id!
      $aggregationLevel: PennylaneAggregationLevelEnum
      $versionData: VersionDataInput
    ) {
      updateAccountingInfoState(
        actionId: $actionId
        missionId: $missionId
        aggregationLevel: $aggregationLevel
        versionData: $versionData
      ) {
        _id
        accountingInfo {
          stateId
        }
      }
    }
  `);

export type MissionAccountingStateForm_UpdateAccountingInfoState_Result =
  ResultOf<
    typeof MissionAccountingStateForm_UpdateAccountingInfoState_Mutation
  >;

export const useUpdateMissionAccountingInfoStateMutation = () =>
  useGraphQLMutation(
    MissionAccountingStateForm_UpdateAccountingInfoState_Mutation,
  );
